var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"col-md-11"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.form.content)}})])]),_c('div',{staticClass:"card-footer"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }